import React from 'react';

import { Channel } from '@kaltura-ott/tvpil-shared';

import { CardSkeleton } from 'components/widgets/CardView/CardSkeleton/CardSkeleton';

import HeroCard from '../HeroCard/HeroCard';

interface Props {
  channel: Channel;
  itemWidth: number;
  imageHeight: number;
  timestamp: number;
  index: number;
}

function HeroCardContainer({ channel, itemWidth, imageHeight, timestamp, index }: Props) {
  if (!channel?.id) {
    return <CardSkeleton height={imageHeight} width={itemWidth} />;
  }
  return (
    <HeroCard imageHeight={imageHeight} itemWidth={itemWidth} channel={channel} timestamp={timestamp} index={index} />
  );
}

export default React.memo(HeroCardContainer);
